import { render, staticRenderFns } from "./FoundationalProperty.vue?vue&type=template&id=61ddb46a&"
import script from "./FoundationalProperty.vue?vue&type=script&lang=js&"
export * from "./FoundationalProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports